import React from 'react';
import { Button } from 'primereact/button';

interface ModalListHeaderProps {
  onDownloadClick?: () => void;
  title: string;
  icon: React.ReactNode;
}

const ModalListHeader: React.FC<ModalListHeaderProps> = ({
  onDownloadClick,
  title,
  icon,
}) => (
  <div className="panel-header">
    <h3>{title}</h3>
    {onDownloadClick && (
      <Button
        icon={icon}
        className="panel-header-download"
        onClick={onDownloadClick}
      />
    )}
  </div>
);

export default ModalListHeader;
